export enum CurrencyCode {
  ARS = 'ARS',
  USD = 'USD',
}

export abstract class CurrencyHelper {
  static toEnumMember(value: string): CurrencyCode {
    switch (value.toUpperCase()) {
      case CurrencyCode.USD:
        return CurrencyCode.USD;
      default:
        return CurrencyCode.ARS;
    }
  }

  static isUSD(value: string): boolean {
    return value && value.trim().toUpperCase() === CurrencyCode.USD;
  }

  static isARS(value: string): boolean {
    return value && value.trim().toUpperCase() === CurrencyCode.USD;
  }

  static getCurrencySymbol(currency: CurrencyCode): string {
    switch (currency) {
      case CurrencyCode.USD:
        return 'u$s';
      default:
        return '$';
    }
  }
}
